const getDataFieldsTable = () => {
  return [
    {
      title: "Rows",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Values",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 25,
      valueType: "Number",
      canEdit :  false
    },
  ];
};

const getCustomizationFieldsTable = () => {
  return [
    {
      title: "Row Total",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isRowTotalVisible",
    },
    {
      title: "Column Total",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isColumnTotalVisible",
    },
    {
      title: "Conditional Formatting",
      type: "CONDITIONAL_FORMATTING",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
    {
      title: "Custom Alignmant",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isCustomAlign",
      innerComponents: [
        {
          title: "Row Align",
          type: "textAlign",
          reduxKey: "rowAlign",
          defaultValue: "left",
        },
        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },
      ],
    },
  ];
};
export { getDataFieldsTable, getCustomizationFieldsTable };
